









import {Vue, Component, Prop, Emit} from 'vue-property-decorator'

@Component({})
export default class Option extends Vue {
  @Prop() value!: any
  @Prop(String) key!: string
  @Prop(String) label!: string

  @Emit('click')
  onClick() {
    return this.value
  }
}
